
/* eslint-disable consistent-return */
/* eslint-disable react/no-unknown-property */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import videojs from 'video.js';
import DetailLayout from '../../layout/Detail';
import Player from '../common/Player';
import { getUserVideoProgress } from '../../utils/localCache.util';
import convertSecToTime from '../../utils/timeformat.util';
import playIcon from '../../assets/images/icons/play.png';
import resumeIcon from '../../assets/images/icons/resume.png';
import restoreFocus from '../../utils/restoreFocus';
import scrollAppView from '../../utils/viewScroll.util';
import { Link, useParams, useLocation } from 'react-router-dom';
import TopMenu from '../common/TopMenu';
import { ArrowLeftIcon, PauseIcon, PlayIcon } from '@heroicons/react/16/solid';
import { PlayPauseIcon } from '@heroicons/react/20/solid';
import defaultImageUrl from "../../assets/images/freemovies/default_image.png";

const DetailPage = ({
  detailPageData: initialDetailPageData,
  handleHideDetailPage,
  videos,
  containerIdPrefix,
  setShowDetailPage,
  activePage: initialActivePage,
  activeSubPage: initialActiveSubPage,
  menuData,
  handlePageChange,
  activePageLayoutType,
}) => {
  const { videoTitle } = useParams();
  const [detailPageData, setDetailPageData] = useState(initialDetailPageData);
  const [showPlayer, setShowPlayer] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [currentProgress, setCurrentProgress] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [activePage, setActivePage] = useState(initialActivePage);
  const [activeSubPage, setActiveSubPage] = useState(initialActiveSubPage);

  const scrollHandleButtonId = `scroll-element-${containerIdPrefix}`;
  const moreLikeThis = videos.filter((a) => a.title !== detailPageData.title);
  window.scrollTo(0, 0);


  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('detailPageData')) || {};
    const videoData = storedData.videos?.find(
      (video) => video.title.replace(/\s+/g, '_').toLowerCase() === videoTitle
    );
    if (videoData) {
      setDetailPageData((prevData) => ({
        ...prevData,
        ...videoData,
      }));
    }
  }, [videoTitle]);

  useEffect(() => {
    try {
      if (window.document.getElementById('bg-video-player')) {
        videojs('bg-player').pause();
      }
    } catch (e) {
      // do nothing
    }
  }, [videos]);

  useEffect(() => {
    const myProgress = getUserVideoProgress(detailPageData.id);
    if (myProgress > 0) {
      setCurrentProgress(Math.ceil(Number(myProgress)));
    } else {
      setCurrentProgress(0);
    }
    setShowButtons(true);
  }, [detailPageData.id]);

  useEffect(() => {
    const combinedData = { detailPageData, videos, containerIdPrefix, activePage };
    localStorage.setItem('detailPageData', JSON.stringify(combinedData));
  }, [detailPageData, videos, containerIdPrefix, activePage]);

  useEffect(() => {
    const playlistId = window.location.pathname.split('/')[2];
    const playlistCategoryId = window.location.pathname.split('/')[3];
    setActivePage(playlistId);
    setActiveSubPage(playlistCategoryId);
  }, []);

  const handleScroll = () => {
    const focusedElements = window.document.querySelectorAll(
      '.prj-element.focused'
    );

    if (focusedElements.length > 0) {
      if (focusedElements[0].id === 'resume-btn') {
      } else if (detailPageData.isPortrait === true) {
        window.document.querySelectorAll(
          '.video-details'
        )[0].style.marginTop = `195px`;
      } else if (detailPageData.isPortrait === false) {
        window.document.querySelectorAll(
          '.video-details'
        )[0].style.marginTop = `239px`;
      }
    }
  };

  const handleScrollEle = () => {
    const focusedElements = window.document.querySelectorAll(
      '.prj-element.focused'
    );

    if (focusedElements.length > 0) {
      scrollAppView(focusedElements[0]);
      window.document.querySelectorAll(
        '.video-details'
      )[0].style.marginTop = `-190px`;
    }
  };

  const fallbackImage = (event, titleName) => {
    const img = event.target;
    img.src = defaultImageUrl;
    img.alt = titleName;
    img.className = "error-image-default-image";
  };

  const toHoursAndMinutes = (totalSeconds) => {
    const totalMinutes = Math.floor(totalSeconds / 60);

    const seconds = totalSeconds % 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) {
      if (minutes === 0) {
        return `${seconds}s`;
      }
      return `${minutes}m ${seconds}s`;
    }

    return `${hours}h ${minutes}m ${seconds}s`;
  };

    function formatDuration(seconds) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const formattedHours = hrs > 0 ? `${hrs.toString().padStart(2, '0')}h` : '';
    const formattedMinutes = mins > 0 ? `${mins.toString().padStart(2, '0')}m` : '';
    return `${formattedHours} ${formattedMinutes}`.trim();
  }
  const formattedTime = formatDuration(detailPageData.duration);

  const clickOnBackButton = () => {
    window.history.back(); 
  };

  return (
    <DetailLayout>
      <>
      <TopMenu
        menuData={menuData}
        activePage={activePage}
        handlePageChange={handlePageChange}
        activePageLayoutType={activePageLayoutType}
      />
      <div className='main-cont'>
        <div
          className="bg-poster"
          style={{ backgroundImage: `url("${detailPageData.posterH}")` }}
        />
        <button
          type="button"
          className="hide"
          id="video-detail-focus"
          onClick={handleScroll}
        >
          Scroll
        </button>
        <div className="bg-poster-layer" />

        <div
          className={
            detailPageData.isPortrait
              ? 'video-details-main-div movies'
              : 'video-details-main-div videos'
          }
          id="video-detail-focus"
        >
          
          <div className="back-to-page prj-element" id="back-to-page" onClick={() => sessionStorage.removeItem('initialUrl')}>
            <ArrowLeftIcon className="" onClick={clickOnBackButton} />
          </div>
          <div className="video-details">
            <div className="image">
              <div
                className={`image-wrap ${
                  detailPageData.isPortrait ? 'portrait' : 'landscape'
                }`}
              >
                <img
                  src={
                    detailPageData.isPortrait
                      ? detailPageData.posterV
                      : detailPageData.posterH
                  }
                  alt={detailPageData.title}
                  loading="lazy" onError={(e) => fallbackImage(e, detailPageData.title)}
                />
              </div>
            </div>              
            <div className="details">
              <div className="title">{detailPageData.title}</div>
              <div className="flex-box">
                {detailPageData.category && (
                  <>
                    {detailPageData.category && (
                    <span className="video-details-category">
                      {detailPageData.category}
                    </span>
                    )}
                  </>
                )}
                {detailPageData.releaseDate && (
                <span className="video-details-release-date">
                  ({detailPageData.releaseDate.split('-')[0]})
                </span>
                )}

                {detailPageData.rating && (
                  <div className="video-rating">
                    <span>{detailPageData.rating}</span>
                  </div>
                )}

                {detailPageData.duration && (
                  <>
                    {detailPageData.releaseDate && (
                    <span className="video-details-duration">
                      {formattedTime}
                    </span>
                    )}
                  </>
                )}
              </div>
              <div className="description">{detailPageData.description}</div>
              <div className="video-rating">
                {detailPageData.director && (
                  <>
                  <h5 className='m-0'>Directors: </h5>
                    {detailPageData.director && (
                        <span>{detailPageData.director}</span>
                    )}
                  </>
                )}
              </div>
              <div className="actor-section">
                <h5 className='m-0'>Cast: </h5>
                {detailPageData.actor1 && (
                  <span className="detail-page-actor1">
                    {detailPageData.actor1}
                  </span>
                )}
                {detailPageData.actor2 && (
                  <>
                    {detailPageData.actor1 && (
                      <span className="detail-page-vertical-line">&#124;</span>
                    )}
                    <span className="detail-page-actor2">
                      {detailPageData.actor2}
                    </span>
                  </>
                )}
                {detailPageData.actor3 && (
                  <>
                    {detailPageData.actor1 || detailPageData.actor2 ? (
                      <span className="detail-page-vertical-line">&#124;</span>
                    ) : (
                      ''
                    )}
                    <span className="detail-page-actor3">
                      {detailPageData.actor3}
                    </span>
                  </>
                )}
              </div>
              {showButtons && (
                <div className="buttons">
                  {currentProgress !== 0 && (
                    <Link
                      to={`/watch/featured/${detailPageData.title.toLowerCase().replace(/\s+/g, '_')}`}
                      id="resume-btn"
                      type="button"
                      className="play-btn prj-element"
                      data-focus-left={false}
                      data-focus-right="#play-btn"
                      data-focus-up={false}
                      data-focus-down=".video.prj-element"
                      data-on-self-focus="#video-detail-focus"
                    >
                      <PlayPauseIcon className='size-6' />
                      Resume from {toHoursAndMinutes(currentProgress)}
                    </Link>
                  )}
                  <Link
                    to={`/watch/featured/${detailPageData.title.toLowerCase().replace(/\s+/g, '_')}`}
                    id="play-btn"
                    type="button"
                    className={
                      currentProgress === 0
                        ? 'play-btn small prj-element '
                        : 'play-btn prj-element beginning-btn '
                    }
                    data-focus-left="#resume-btn"
                    data-focus-right={false}
                    data-focus-up={false}
                    data-focus-down=".video.prj-element"
                    data-on-self-focus="#video-detail-focus"
                  >
                    <PlayIcon className='size-6' />
                    {currentProgress === 0 ? 'Play' : 'Play from beginning'}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      </>
    </DetailLayout>
  );
};

DetailPage.propTypes = {
  detailPageData: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    poster: PropTypes.string,
    posterH: PropTypes.string,
    posterV: PropTypes.string,
    hlsUrl: PropTypes.string,
    isPortrait: PropTypes.bool,
    genres: PropTypes.string,
    duration: PropTypes.number,
    category: PropTypes.string,
    channelId: PropTypes.number,
    director: PropTypes.string,
    actor1: PropTypes.string,
    actor2: PropTypes.string,
    actor3: PropTypes.string,
    rating: PropTypes.string,
    releaseDate: PropTypes.string,
    ratingSource: PropTypes.string,
    season: PropTypes.number,
    episode: PropTypes.number,
    srtUrl: PropTypes.string,
    vttUrl: PropTypes.string,
    source: PropTypes.string,
    playDirectUrl: PropTypes.string,
    liveVastUrl: PropTypes.string,
  }).isRequired,
  handleHideDetailPage: PropTypes.func.isRequired,
  setShowDetailPage: PropTypes.func.isRequired,
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
      shortDescription: PropTypes.string,
      hlsUrl: PropTypes.string,
      poster: PropTypes.string,
      posterH: PropTypes.string,
      posterV: PropTypes.string,
      startTime: PropTypes.string,
      endTime: PropTypes.string,
      duration: PropTypes.number,
      type: PropTypes.string,
      genres: PropTypes.string,
      category: PropTypes.string,
      channelId: PropTypes.number,
      director: PropTypes.string,
      actor1: PropTypes.string,
      actor2: PropTypes.string,
      actor3: PropTypes.string,
      rating: PropTypes.string,
      releaseDate: PropTypes.string,
      ratingSource: PropTypes.string,
      season: PropTypes.number,
      episode: PropTypes.number,
      srtUrl: PropTypes.string,
      vttUrl: PropTypes.string,
      source: PropTypes.string,
      playDirectUrl: PropTypes.string,
      liveVastUrl: PropTypes.string,
    })
  ).isRequired,
  containerIdPrefix: PropTypes.string.isRequired,
};

export default DetailPage;
